import React from 'react';
import PropTypes from 'prop-types';

import {
  Picker,
  TextInput,
  Text,
  Platform,
  ActionSheetIOS,
  TouchableOpacity,
} from 'react-native';
import styles from '../../styles';

class ListPicker extends React.Component {
  static getDerivedStateFromProps(props, state) {
    if (!state.dirty && props.value !== state.value) {
      return {
        value: props.value,
      };
    }
    return {};
  }

  constructor(props, context) {
    super(props, context);

    this.showActionSheet = this.showActionSheet.bind(this);

    const { value } = this.props;

    this.state = {
      dirty: false,
      value,
    };
  }

  showActionSheet = () => {
    const { onChange, options } = this.props;

    ActionSheetIOS.showActionSheetWithOptions(
      {
        options: ['Cancel', ...options.map((option) => option.label)],
        cancelButtonIndex: 0,
        tintColor: 'green',
      },
      (buttonIndex) => {
        console.log('clicked');
        console.log(buttonIndex);
        if (buttonIndex > 0) {
          this.setState({
            dirty: true,
            value: options[buttonIndex - 1].value,
          });
          onChange(options[buttonIndex - 1].value);
        }
      }
    );
  };

  render() {
    const {
      style, onChange, options,
    } = this.props;
    const {
      value,
    } = this.state;

    let label = value;

    options.forEach((option) => {
      if (option.value === value) {
        label = option.label;
      }
    });

    if (Platform.OS === 'ios') {
      return (
        <TouchableOpacity
          style={{
            flex: 1,
            alignItems: 'flex-start',
            justifyContent: 'center',
            minHeight: style.minHeight,
            height: style.minHeight,
            backgroundColor: style.backgroundColor,
          }}
          onPress={this.showActionSheet}
        >
          <Text
            style={{
              fontSize: style.fontSize,
            }}
          >
            {label}
          </Text>
        </TouchableOpacity>
      );
    }

    const styleItem = {
      fontSize: style.fontSize,
      minHeight: style.minHeight,
      height: style.minHeight,
      paddingVertical: 8,
      backgroundColor: style.backgroundColor || 'white',
      fontFamily: style.fontFamily || styles.primaryFont300,
      fontWeight: style.fontWeight || '300',
    };
    const stylePicker = {
      borderWidth: 0,
      backgroundColor: style.backgroundColor || 'white',
      paddingHorizontal: style.paddingHorizontal !== undefined ? style.paddingHorizontal : 20,
      fontSize: style.fontSize,
      fontFamily: style.fontFamily || styles.primaryFont300,
      fontWeight: style.fontWeight || '300',
    };
    if (style.width !== undefined) {
      styleItem.width = style.width;
      stylePicker.width = style.width;
    }

    if (Platform.OS === 'web') {
      stylePicker['-webkit-appearance'] = 'none';
      stylePicker['-webkit-touch-callout'] = 'none';
      stylePicker['-webkit-user-select'] = 'none';
      stylePicker['-moz-user-select'] = 'none';
      stylePicker['-ms-user-select'] = 'none';
      stylePicker['user-select'] = 'none';
    }

    return (
      <Picker
        mode="dialog" // TODO(clairbee): Android only???
        onValueChange={onChange}
        selectedValue={value}
        itemStyle={styleItem}
        style={stylePicker}
      >
        {options.map((option) => (
          <Picker.Item key={option.value} label={option.label} value={option.value} />
        ))}
      </Picker>
    );
  }
}

ListPicker.defaultProps = {
  style: () => undefined,
};

ListPicker.propTypes = {
  onChange: PropTypes.func.isRequired,
  style: PropTypes.object, //: TextInput.propTypes.style,
  value: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
};

export default ListPicker;
